import type {
  BlueprintBindingValue,
  BlueprintModifier,
} from '@/grove-blueprints/generated-types'

export function resolveVisibilityModifier(
  modifiers: BlueprintModifier[] | undefined,
  bindingValues: Record<string, BlueprintBindingValue>,
): 'contents' | 'hidden' | undefined {
  if (modifiers === undefined) {
    return undefined
  }

  const visibleModifier = modifiers.find(
    (modifier) => modifier.type === 'visible',
  )

  if (visibleModifier === undefined) {
    return undefined
  }

  // @ts-ignore: The type-narrowing is not working as expected in this project.
  const bindingValue = bindingValues[visibleModifier.binding]

  // @ts-ignore: The type-narrowing is not working as expected in this project.
  return String(bindingValue) === String(visibleModifier.equals)
    ? 'contents'
    : 'hidden'
}
